import { closeSubscriptionExtensionModal, openSubscriptionExtensionModal } from '../modules/ui';
import type { EventHandlerDeps } from './globalEventTypes';

export function setupSubscriptionExtensionHandlers(deps: EventHandlerDeps): void {
  const { els } = deps;

  if (els.superadminExtendSubscriptionBtn) {
    els.superadminExtendSubscriptionBtn.addEventListener('click', () => {
      openSubscriptionExtensionModal();
    });
  }

  if (els.closeSubscriptionExtensionModal) {
    els.closeSubscriptionExtensionModal.addEventListener('click', () => {
      closeSubscriptionExtensionModal();
    });
  }

  if (els.subscriptionExtensionCancel) {
    els.subscriptionExtensionCancel.addEventListener('click', () => {
      closeSubscriptionExtensionModal();
    });
  }

  if (els.subscriptionExtensionModalBackdrop) {
    els.subscriptionExtensionModalBackdrop.addEventListener('click', () => {
      closeSubscriptionExtensionModal();
    });
  }

  if (els.subscriptionExtensionForm) {
    els.subscriptionExtensionForm.addEventListener(
      'submit',
      deps.handleSubscriptionExtensionSubmit
    );
  }

  if (els.subscriptionExtensionNote && els.subscriptionNoteCharCount) {
    els.subscriptionExtensionNote.addEventListener('input', () => {
      if (els.subscriptionNoteCharCount) {
        els.subscriptionNoteCharCount.textContent = (
          els.subscriptionExtensionNote as HTMLTextAreaElement
        ).value.length.toString();
      }
    });
  }
}
